import { HTMLProps, ReactNode } from "react";
import styles from "./CoreOrderedList.module.css";

export function CoreOrderedListItem({ children }: { children: ReactNode }) {
	return (
		<li className={styles.filledNumberedListItem}>
			<div>{children}</div>
		</li>
	);
}

export default function CoreOrderedList({ className, children }: HTMLProps<HTMLOListElement>) {
	return <ol className={`${styles.filledNumberedList} ${className || ""}`}>{children}</ol>;
}
